import { ScaleDefinition } from '../../models/dynamic-scale.model';
import { SCALE_TYPE } from '../scale-type.enum';

export const NRS_SCALE: ScaleDefinition = {
  idRef: SCALE_TYPE.NRS_SCALE,
  title: 'Numeric Rating Scale (NRS) - Dolore',
  scoreConfig: {
    scoreKey: 'nrs_media',
    scoreFields: ['nrs_attuale', 'nrs_medio_7g', 'nrs_peggiore_7g'],
  },
  sections: [
    {
      name: 'nrs',
      label: 'Numeric Rating Scale (NRS) - Dolore',
      fields: [
        {
          key: 'nrs_attuale',
          label: 'Dolore attuale (0–10)',
          type: 'number',
          min: 0,
          max: 10,
          step: 1,
          maxScore: 10,
          valueDescriptions: {
            '0': 'Nessun dolore.',
            '1': 'Dolore molto lieve.',
            '3': 'Dolore lieve.',
            '5': 'Dolore moderato.',
            '7': 'Dolore intenso.',
            '10': 'Dolore insopportabile / massimo immaginabile.',
          },
          description:
            'Valuta l’intensità del dolore in questo momento, su una scala da 0 (nessun dolore) a 10 (peggiore dolore immaginabile).',
        },
        {
          key: 'nrs_medio_7g',
          label: 'Dolore medio ultimi 7 giorni (0–10)',
          type: 'number',
          min: 0,
          max: 10,
          step: 1,
          maxScore: 10,
          valueDescriptions: {
            '0': 'Nessun dolore in media.',
            '3': 'Dolore lieve in media.',
            '5': 'Dolore moderato in media.',
            '7': 'Dolore intenso in media.',
            '10': 'Dolore molto intenso in media.',
          },
          description:
            'Valuta mediamente quanto dolore hai avvertito negli ultimi 7 giorni (0–10).',
        },
        {
          key: 'nrs_peggiore_7g',
          label: 'Dolore peggiore ultimi 7 giorni (0–10)',
          type: 'number',
          min: 0,
          max: 10,
          step: 1,
          maxScore: 10,
          valueDescriptions: {
            '0': 'Nessun dolore.',
            '5': 'Dolore moderato.',
            '10': 'Dolore massimo / peggiore immaginabile.',
          },
          description:
            'Indica l’intensità del dolore più forte provato negli ultimi 7 giorni (0–10).',
        },
      ],
    },
  ],
  computedFields: [
    // MEDIA NRS (scoreKey)
    {
      key: 'nrs_media',
      label: 'NRS medio (0–10)',
      type: 'number',
      calculation: 'ROUND( AVG(scoreConfig.sumOf), 1 )',
      maxScore: 10,
    },
    // RANGE PIÙ ALTO (può essere utile in UI)
    {
      key: 'nrs_massimo',
      label: 'Valore massimo riportato (0–10)',
      type: 'number',
      calculation: 'MAX([nrs_attuale, nrs_medio_7g, nrs_peggiore_7g])',
      maxScore: 10,
    },
    // INTERPRETAZIONE CLINICA basata sulla media
    {
      key: 'interpretazione',
      label: 'Interpretazione del dolore',
      type: 'text',
      calculation: `
        IF(nrs_media <= 0, "Assenza di dolore",
          IF(nrs_media <= 3, "Dolore lieve",
            IF(nrs_media <= 6, "Dolore moderato",
              "Dolore severo"
            )
          )
        )
      `,
      maxScore: 0,
    },
  ],
};
